import { XCircleIcon } from '@heroicons/react/24/solid'
import LoadingEllipsis from './common/LoadingEllipsis'

const ProcessLog = ({ logOutput, setShowLog }) => {
  return (
    <div
      className='border-gray-300 bg-gray-50 relative mx-auto mt-3 rounded-lg border border-solid p-3 opacity-30 shadow-sm'
      style={{ maxWidth: '50%' }}
    >
      <button
        className='text-gray-400 hover:text-gray-600 absolute right-2 top-2 cursor-pointer'
        onClick={() => setShowLog(false)}
        aria-label='Close'
      >
        <XCircleIcon className='h-5 w-5' />
      </button>

      <div className='max-h-[200px] overflow-y-auto pt-1 font-mono text-sm'>
        {logOutput.map((log, index) => (
          <div
            key={index}
            className='flex items-start py-0.5 leading-snug'
            ref={
              index === logOutput.length - 1
                ? (el) => el?.scrollIntoView({ behavior: 'smooth' })
                : null
            }
          >
            {log.loading ? (
              <div className='text-blue-600 flex items-center'>
                <span className='text-gray-500 mr-2 select-none'>$</span>
                {log.message}
                <LoadingEllipsis loading={true} />
              </div>
            ) : index === logOutput.length - 1 ? (
              <div className='text-green-600 flex items-center'>
                <span className='text-gray-500 mr-2 select-none'>$</span>
                {log.message}
              </div>
            ) : (
              <div className='text-gray-700 flex items-center'>
                <span className='text-gray-500 mr-2 select-none'>$</span>
                {log.message}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ProcessLog
